import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'de',
  data: {
    'GENERICSURVEY': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Allgemeiner Umfragebericht',
      'SUBTITULO': 'Konsultieren Sie den generischen Umfragebericht durch Eingabe von',
      'CAMPOS': {
        'Token': 'Token:',
      },
      'RESULTADOS': {
        'CARGANDO': 'Laden der Suchergebnisse',
        'TITULO': 'Ergebnisse',
        'ENCONTRADAS': 'Benutzer insgesamt gefunden',
        'DESCARGAR': 'Informationen im Excel-Format herunterladen',
        'SINRESULTADOS': 'Keine Benutzer für das angegebene Token gefunden'
      }
    }
  }
};
